import basicArrow from './src/BasicArrow.vue';
import basicHelp from './src/BasicHelp.vue';

export const BasicArrow = basicArrow
export const BasicHelp = basicHelp
